export default "__VITE_ASSET__BgOeuEr___"